(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  const firstSectionImage = document.querySelector('.main-content > .shopify-section img');
  if (firstSectionImage) {
    firstSectionImage.setAttribute('loading', 'eager');
    firstSectionImage.setAttribute('fetchpriority', 'high');
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["img-hero-slider"] && !Shopify.designMode) return;
  try {
    
// Hero slider
$(document).ready(function(){
  let slideImages = $('.hero-slide');
  let current = 0;
  let interval = setInterval(function(){
    nextSlide();
  },5000);


  $('#sliderContainer').on('mouseenter', function(){
    clearInterval(interval);
  });


  // Clear All Images
  function reset(){
    for(let i = 0; i < slideImages.length; i++){
      slideImages[i].classList.remove('slide-active');
    }
  }

  function startSlide(){
    reset();
    slideImages[0].classList.add('slide-active');
    $('#slideCurrent').text(current + 1);
  }

  // Show Prev
  function slideLeft(){
    reset();
    slideImages[current - 1].classList.add('slide-active');
    current--;
  }

  // Left Arrow Click
  $('#prev').on('click', function(){
    if(current === 0){
      current=slideImages.length;
    }
    slideLeft()
    $('#slideCurrent').text(current + 1);
  })

  // Show Next
  function slideRight(){
      reset();
      slideImages[current + 1].classList.add('slide-active');
      current++;
  }

  function nextSlide(){
    if(current === slideImages.length -1){
      current=-1;
    }
    slideRight()
    $('#slideCurrent').text(current +1);
  }

  //Right Arrow Click
  $('#next').on('click', function(){
    nextSlide();
  })

  // Insert Total Slides
  $('#slideTotal').text(slideImages.length);

  startSlide();
});

  } catch(e) { console.error(e); }
})();
})();
